const authorFromScratch = {
  topicId: "nualang.author-from-scratch.0.0.1",
  topicName: "Crea desde cero",
  description: "",
  difficulty: "ALL",
  learnLang: "spanish",
};

export default authorFromScratch;
